import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const AuthzSubject = React.lazy(() =>
    import('../AuthzSubject')
);
const authzSubjectRoutesRegistry = [
    {
        path: PAGE_URL.AUTHZ_SUBJECT_PAGE,
        element: <AuthzSubject />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default authzSubjectRoutesRegistry;
